export type HeaderNotificationGroup = string;

export const DEFAULT_NOTIFICATION_PANEL_VIEW = 'feed' as const;

export type HeaderNotificationItem = {
  id: number;
  message: string;
  date: string;
  category: string;
  group: HeaderNotificationGroup;
  avatarSrc?: string;
  fallbackInitial: string;
  href?: string;
  trackingProperties?: Record<string, string>;
  unread?: boolean;
};

export type HeaderNotificationSource = {
  items: HeaderNotificationItem[];
  groups: { id: HeaderNotificationGroup; name: string }[];
  totalUnread: number | null;
  isLoading: boolean;
  isLoadingMore: boolean;
  isMutating: boolean;
  error: string | null;
  actionError: string | null;
  preferences: NotificationPreference[];
  preferenceValues: Record<string, boolean>;
  isPreferencesLoading: boolean;
  preferenceError: string | null;
  updatingPreferenceId: string | null;
  hasMore: boolean;
  onOpen: () => void;
  onClose: () => void;
  onLoadMore: () => void;
  onRetry: () => void;
  onMarkRead: (id: number) => void;
  onMarkUnread: (id: number) => void;
  onMarkAllRead: () => void;
  onLoadPreferences: () => void;
  onUpdatePreference: (id: string, value: boolean) => void;
};

export type NotificationPreference = {
  id: string;
  label: string;
  description: string;
};

export const NOTIFICATION_PREFERENCES: NotificationPreference[] = [
  {
    id: 'community',
    label: 'Cộng đồng',
    description:
      'Tất cả thông báo về các tương tác với cộng đồng trong mục Thảo luận',
  },
  {
    id: 'news_updates',
    label: 'Tin tức & Cập nhật',
    description:
      'Tất cả thông báo về tính năng mới, khảo sát và các sự kiện đặc biệt từ Upzi',
  },
  {
    id: 'chat',
    label: 'Chat',
    description: 'Tất cả thông báo về chat',
  },
  {
    id: 'reco_job',
    label: 'Gợi ý việc làm',
    description: 'Tất cả thông báo về gợi ý việc làm mới và phù hợp với bạn',
  },
  {
    id: 'application_status',
    label: 'Trạng thái ứng tuyển',
    description: 'Tất cả thông báo về trạng thái ứng tuyển việc làm của hồ sơ',
  },
];
